import React from "react";
import styles from "./no-perms-card.module.scss";
import { PiEmpty } from "react-icons/pi";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import type {
  GrantedPermission,
  Permission,
} from "@/types/modular-permissions.types";
import { type Config, type UseAccountReturnType } from "wagmi";

type Props = {
  isLoading: boolean;
  accountStatus: UseAccountReturnType<Config>;
  permissions: GrantedPermission[] | Permission[];
  mirroredCard?: boolean;
};

const NoPermsExistCard = ({
  isLoading,
  permissions,
  mirroredCard = false,
  accountStatus,
}: Props) => {
  const { isDelegateBeingCreated } = useModularPermissionsStore();

  if ((!isLoading && !permissions.length) || !accountStatus.isConnected)
    if (mirroredCard)
      return (
        <div className={styles.mirroredContainer}>
          <PiEmpty size={30} />
          <span>No mirrored permissions</span>
        </div>
      );
    else if (!isDelegateBeingCreated) {
      return (
        <div className={styles.container}>
          <PiEmpty size={30} />
          <span>No permissions</span>
        </div>
      );
    }
};

export default NoPermsExistCard;
